export class MensajesGenericosConstants {
    public static NO_EXISTEN_REGISTROS = "No existen registros";
    public static NO_EXISTEN_RESULTADOS_FILTRO = "No se encuentran resultados para este filtro";
    public static SESION_NO_VALIDA = 'Sesión no válida';
    public static SIN_PERMISO_RUTA = 'Sin permiso para esa ruta';
    public static LA_ACCAI_ACTUAL_ES_DIFERENTE_AL_ACCAI_DEL_USUARIO: string = "La entidad actual del afiliado es DIFERENTE a la entidad del usuario de LOGIN.";
    public static EL_USUARIO_CANCELO_LA_OPERACION: string = "El usuario canceló la operación";
    public static EL_AFILIADO_AL_QUE_CONSULTA_NO_EXISTE_O_NO_PERTENECE_A_SU_ENTIDAD: string = "El afiliado al que consulta no existe o no pertenece a su entidad";
}
